// Configuration for different environments
//http://192.168.0.208:5156/
//https://cocacola-dev-winitapi.winitsoftware.com/
const config = {
  development: {
    API_BASE_URL: 'http://192.168.0.208:5156/api',
    WEB_API_BASE_URL: 'https://cocacola-dev-web.winitsoftware.com/api',
    FILE_BASE_URL: 'https://cocacola-dev-web.winitsoftware.com',
    APP_NAME: 'CDE Customer Portal',
    VERSION: '1.0.1',
  },
  dev: {
    API_BASE_URL: 'https://cocacola-dev-api.winitsoftware.com/api',
    WEB_API_BASE_URL: 'https://cocacola-dev-web.winitsoftware.com/api',
    FILE_BASE_URL: 'https://cocacola-dev-web.winitsoftware.com',
    APP_NAME: 'CDE Customer Portal',
    VERSION: '1.0.1',
  },
  uat: {
    // TEMP: point MobileService at local for testing OTP/sync. Restore the UAT URL below before deploying.
    API_BASE_URL: 'https://cocacola-uat-api.winitsoftware.com/api',
    // API_BASE_URL: 'http://localhost:5156/api',
    WEB_API_BASE_URL: 'https://cocacola-uat-web.winitsoftware.com/api',
    // WEB_API_BASE_URL: 'http://localhost:35257/api',
    FILE_BASE_URL: 'https://cocacola-uat-web.winitsoftware.com',
    APP_NAME: 'CDE Customer Portal',
    VERSION: '1.0.1',
  },
  production: {
    API_BASE_URL: 'https://cdeplus-api.winitsoftware.com/api',
    WEB_API_BASE_URL: 'https://cdeplus-web.winitsoftware.com/api',
    FILE_BASE_URL: 'https://cdeplus-web.winitsoftware.com',
    APP_NAME: 'CDE Customer Portal',
    VERSION: '1.0.1',
  },
};

// Determine current environment
// Use REACT_APP_ENV to specify environment (uat, production), defaults based on NODE_ENV
const getEnvironment = (): 'development' | 'dev' | 'uat' | 'production' => {
  const customEnv = process.env.REACT_APP_ENV;
  if (customEnv === 'dev') return 'dev';
  if (customEnv === 'uat') return 'uat';
  if (customEnv === 'production') return 'production';
  if (customEnv === 'development') return 'development';
  // Default: production build = production, otherwise development
  return process.env.NODE_ENV === 'production' ? 'production' : 'development';
};

const environment = getEnvironment();
console.log(`Running in ${environment} environment`);

// Export current environment config
export const appConfig = config[environment];

// Export individual values for convenience
export const API_BASE_URL = appConfig.API_BASE_URL;
export const WEB_API_BASE_URL = appConfig.WEB_API_BASE_URL;
export const FILE_BASE_URL = appConfig.FILE_BASE_URL;
export const APP_NAME = appConfig.APP_NAME;
export const VERSION = appConfig.VERSION;

export default appConfig;